<form [formGroup]="manualQuizForm">
<div class="quiz-container">
    <div class="left-pane">
        <div class="quiz-section">

            <app-question-type [(selected)]="selectedQuizType"></app-question-type>
            <div *ngIf="selectedQuizType === QuizQuestionType.MCQ" class="mcq-block">
                <label class="form-label">Question Text*</label>
                <textarea class="question-text" placeholder="Add your question here." formControlName="questionText"></textarea>
				
				<small *ngIf="manualQuizForm.get('questionText')?.invalid &&
                manualQuizForm.get('questionText')?.touched" class="text-danger smaller-text">
                Question is required</small>

                <div class="mt-3 mb-3">
                    <input type="file" #imageUpload accept=".jpg,.jpeg,.png" style="display: none" (change)="onImageUpload($event)">
                    <button type="button" class="upload-btn" (click)="imageUpload.click()">
                        <i class="bi bi-image"></i> Upload Image (optional)
                    </button>
                    <div *ngIf="uploadedImageUrl" class="uploaded-image-preview mt-2 d-flex align-items-center">
                        <img [src]="uploadedImageUrl" alt="Question Image" width="100" height="auto" class="rounded">
                        <i class="bi bi-trash ms-2 text-danger cursor-pointer fs-5" (click)="removeImage()"></i>
                    </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mb-3">
					<div class="text-start">
                    <label class="form-label mb-0">Answer Options</label>
					<p class="remind me-3" *ngIf="selectedAnswer === null">Please Select the correct answer before saving</p></div>
                    <button class="add-option-btn" (click)="addOption()" *ngIf="options.length < 4">
                        <i class="bi bi-plus-lg"></i> Add Option
                    </button>
                </div>

               <div formArrayName="options">
                <div class="option-row" *ngFor="let optionCtrl of options.controls; let i = index" [formGroupName]="i">
                    <img src="assets/images/option.svg">
                    <input type="radio" name="correct" [value]="i" (change)="selectAnswer(i)" />
                    <input class="option-input" formControlName="text" [placeholder]="'Option ' + (i + 1)" />
                    <i class="bi bi-trash option-icon delete" (click)="removeOption(i)" *ngIf="options.length > 2"></i>
				</div>
				<small *ngIf="manualQuizForm.get('options')?.errors?.['duplicateOptions'] && 
				(manualQuizForm.get('options')?.touched || manualQuizForm.get('options')?.dirty)"  class="text-danger smaller-text">
                Duplicate options are not allowed.</small>

			</div>

                <div class="question-input-section">
                    <div class="continue-btn-wrapper">
						<ng-container *hasPermission="PermissionForStudents.QUIZ_UPDATE">
                        <button class="continue-btn" (click)="submitManualQuestions()"
                 [disabled]="manualQuizForm.get('options')?.errors?.['duplicateOptions']">
				 <div class="btn-content">Continue</div>
				</button>
					  </ng-container>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedQuizType ===  QuizQuestionType.TRUE_FALSE" class="truefalse-block">
                <label class="form-label">Question Text*</label>
                <textarea class="question-text" placeholder="Add your question here." formControlName="tfQuestionText"></textarea>
			<small *ngIf="manualQuizForm.controls['tfQuestionText'].errors?.['required'] && 
			manualQuizForm.controls['tfQuestionText'].touched" class="text-danger smaller-text">Question is required</small>

                <div class="mt-3 mb-3">
                    <input type="file" #imageUploadTF accept=".jpg,.jpeg,.png" style="display: none" (change)="onImageUpload($event)">
                    <button type="button" class="upload-btn" (click)="imageUploadTF.click()">
                        <i class="bi bi-image"></i> Upload Image (optional)
                    </button>
                    <div *ngIf="uploadedImageUrl" class="uploaded-image-preview mt-2 d-flex align-items-center">
                        <img [src]="uploadedImageUrl" alt="Question Image" width="100" height="auto" class="rounded">
                        <i class="bi bi-trash ms-2 text-danger cursor-pointer fs-5" (click)="removeImage()"></i>
                    </div>
                </div>

                <div class="truefalse-options">
                    <label class="tf-option">
                        <input type="radio" name="truefalse" formControlName="selectedTF" [value]="true" />
                        <span>True</span>
                    </label>
                    <label class="tf-option">
                        <input type="radio" name="truefalse" formControlName="selectedTF" [value]="false" />
                        <span>False</span>
                    </label>
                </div>
				 <small *ngIf="manualQuizForm.controls['selectedTF'].errors?.['required'] &&
				  manualQuizForm.controls['selectedTF'].touched" class="text-danger smaller-text">
                  Please select True or False.
                 </small>

                <div class="question-input-section">
                    <div class="continue-btn-wrapper">
						<ng-container *hasPermission="PermissionForStudents.QUIZ_UPDATE">
                        <button class="continue-btn" (click)="submitManualQuestions()">
						<div class="btn-content">Continue</div>	
						</button>
						</ng-container>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedQuizType === QuizQuestionType.OPEN_ENDED" class="open-ended-question">
                <label class="field-label">Question Text*</label>
                <textarea class="input-field" formControlName="openQuestionText" placeholder="Add your question here..."
                    rows="3"></textarea>
					<small *ngIf="manualQuizForm.get('openQuestionText')?.invalid &&
                    manualQuizForm.get('openQuestionText')?.touched" class="text-danger smaller-text">Question is required</small>

                <div class="mt-3 mb-3">
                    <input type="file" #imageUploadOpen accept=".jpg,.jpeg,.png" style="display: none" (change)="onImageUpload($event)">
                    <button type="button" class="upload-btn" (click)="imageUploadOpen.click()">
                        <i class="bi bi-image"></i> Upload Image (optional)
                    </button>
                    <div *ngIf="uploadedImageUrl" class="uploaded-image-preview mt-2 d-flex align-items-center">
                        <img [src]="uploadedImageUrl" alt="Question Image" width="100" height="auto" class="rounded">
                        <i class="bi bi-trash ms-2 text-danger cursor-pointer fs-5" (click)="removeImage()"></i>
                    </div>
                </div>

                <label class="field-label">Key Answer</label>
                <textarea class="input-field" formControlName="openKeyAnswer"
                    placeholder="Add a reference answer to help with evaluating student responses accurately." rows="3"></textarea>
					<small *ngIf="manualQuizForm.get('openKeyAnswer')?.invalid &&
                    manualQuizForm.get('openKeyAnswer')?.touched" class="text-danger smaller-text">Answer is required</small>

                <div class="question-input-section">
                    <div class="continue-btn-wrapper">
						<ng-container *hasPermission="PermissionForStudents.QUIZ_UPDATE">
                        <button class="continue-btn" (click)="submitManualQuestions()">
						<div class="btn-content">Continue</div>
						</button>
						</ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="right-pane">
        <app-question-preview [isPreviewVisible]="showPreview"></app-question-preview>
    </div>
</div>
</form>